import { PolymerElement} from '@polymer/polymer/polymer-element.js';
import template from './my-site-product-details.html';
import { PriceType } from '@nuskin/ns-shop';
import { MySiteApp} from '../../../my-site-app'
import { nuskin } from '@nuskin/ns-util'

/**
 * @customElement
 * @polymer
 */
export class MySiteProductDetails extends PolymerElement {

    constructor() {
        super();
        this.cutAtChar = 35;
    }

    ready() {
        super.ready();
        this.mySite = document.querySelector(MySiteApp.is);
        if(this.mySite && this.mySite.mySiteData) {
            let lang = this.mySite.mySiteData.storefront[this.mySite.subdomain][this.mySite.currentMarket].lang[this.mySite.currentLanguage]
            this.set('price', this.product.priceMap ? this.product.priceMap[lang.retail ? PriceType.WRTL : PriceType.WWHL] : '') 
        }
    }
  
    connectedCallback() {
        this.mySite.addEventListener('my-site-data-changed', this.getMySiteData.bind(this));
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get is() {
        return 'my-site-product-details';
    }

    static get properties() {
        return {
            product: {
                type: Object
            },
            price: {
                type: String
            }
        }
    }

    getMySiteData() {
        if(this.product && this.mySite && this.mySite.mySiteData) {
            let lang = this.mySite.mySiteData.storefront[this.mySite.subdomain][this.mySite.currentMarket].lang[this.mySite.currentLanguage]
            this.set('price', this.product.priceMap ? this.product.priceMap[lang.retail ? PriceType.WRTL : PriceType.WWHL]: '')
        }
    }

    getTitle(title) {
        return title && title.length > this.cutAtChar ? title.slice(0,this.cutAtChar) + '...' : title;
    }

    getPrice() {
        let price = this.product.priceMap ? this.product.priceMap[this.retail ? PriceType.WRTL : PriceType.WWHL] : ''
        return price
    }

    getImgUrl(url) {

        try {
            this.$.img.className = '';
        } catch (err){console.log(err)}

        if(url[0]==='/') 
            return nuskin.configuration.siteUrl + url
        else
            return url;
    }
}

window.customElements.define(MySiteProductDetails.is, MySiteProductDetails);
